<template>
	<!-- Selezione personalizzata delle voci di un KPI della commessa: in secondo piano rispetto al calcolo
		automatico, che resta il default. Le voci del calcolo automatico sono marcate "auto" -->
	<v-menu offset-y left :close-on-content-click="false" max-width="340">
		<template v-slot:activator="{ on, attrs }">
			<v-btn x-small text :color="isDefault ? '' : 'warning'" class="px-1 text-none" v-bind="attrs" v-on="on">
				<v-icon x-small left>mdi-tune-variant</v-icon>
				Personalizza
			</v-btn>
		</template>
		<v-card class="background-2">
			<v-card-subtitle class="pb-1 pt-3">{{ title }}</v-card-subtitle>
			<v-list dense class="background-2 py-0">
				<v-list-item-group :value="value" multiple @change="$emit('input', $event)">
					<v-list-item v-for="item in items" :key="item.value" :value="item.value">
						<template v-slot:default="{ active }">
							<v-list-item-action class="my-0 mr-3">
								<v-checkbox :input-value="active" dense hide-details class="mt-0 pt-0"></v-checkbox>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>
									{{ item.text }}
									<span v-if="defaults.includes(item.value)" class="caption text--secondary ml-1">auto</span>
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action class="my-0">
								<v-list-item-action-text class="body-2">{{ item.subtract ? '−' : '' }}{{ item.total | currency }}</v-list-item-action-text>
							</v-list-item-action>
						</template>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn small text color="primary" :disabled="isDefault" @click="$emit('input', defaults.slice())">
					<v-icon small left>mdi-restore</v-icon>
					Calcolo automatico
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: 'CommissionKpiCustomize',
	props: {
		// voci selezionate (v-model)
		value: {
			type: Array,
			required: true
		},
		// voci disponibili: { value, text, total, subtract }
		items: {
			type: Array,
			required: true
		},
		// voci del calcolo automatico
		defaults: {
			type: Array,
			required: true
		},
		isDefault: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: 'Voci da sommare'
		}
	}
}
</script>
